import {
  Chip,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import styles from "./FilterOptions.module.css";

const FilterOptions = ({
  setSearchStaring,
  searchString,
  setStatus,
  status,
  getResult,
  setFromDate,
  fromDate,
  setToDate,
  toDate,
  setSelectCategory,
  selectCategory,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [urlSearchParams, setUrlSearchParams] = useState();

  useEffect(() => {
    let params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    setUrlSearchParams(params);
    handleChangeStatus(
      searchParams.get("status") ? searchParams.get("status") : "All"
    );
    handleChangeCategory(
      searchParams.get("category") ? searchParams.get("category") : "All"
    );
  }, []);

  const handleChangeStatus = (updateStatus) => {
    setStatus(updateStatus);
    if (updateStatus === "All") {
      getResult({ status: "", page: 1 });
    } else {
      getResult({ status: updateStatus, page: 1 });
    }
  };

  const handleChangeCategory = (updateCategory) => {
    setSelectCategory(updateCategory);
    if (updateCategory === "All") {
      getResult({ category: "", page: 1 });
    } else {
      getResult({ category: updateCategory, page: 1 });
    }
  };
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateRangeChange = (range) => {
    if (range) {
      const [start, end] = range;
      setFromDate(formatDate(start));
      setToDate(formatDate(end));
      getResult({
        from_date: formatDate(start) ? formatDate(start) : "",
        to_date: formatDate(end) ? formatDate(end) : "",
        page: 1,
      });
    } else {
      setFromDate(null);
      setToDate(null);
      getResult({
        from_date: "",
        to_date: "",
        page: 1,
      });
    }
  };

  return (
    <div className={styles.filteroptions}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Chip
          className="statusChip"
          label="All"
          variant="outlined"
          onClick={() => handleChangeStatus("All")}
          style={{
            backgroundColor: status === "All" ? "#A3BE3C" : "#fff",
            color: status === "All" ? "white" : "#000",
          }}
        />
        <Chip
          className="statusChip"
          label="To-Start"
          variant="outlined"
          onClick={() => handleChangeStatus("TO-START")}
          style={{
            backgroundColor: status === "TO-START" ? "#A3BE3C" : "#fff",
            color: status === "TO-START" ? "white" : "#000",
          }}
        />
        <Chip
          className="statusChip"
          label="In-Progress"
          variant="outlined"
          onClick={() => handleChangeStatus("IN-PROGRESS")}
          style={{
            backgroundColor: status === "IN-PROGRESS" ? "#A3BE3C" : "#fff",
            color: status === "IN-PROGRESS" ? "white" : "#000",
          }}
        />
        <Chip
          className="statusChip"
          label="Completed"
          variant="outlined"
          onClick={() => handleChangeStatus("COMPLETED")}
          style={{
            backgroundColor: status === "COMPLETED" ? "#A3BE3C" : "#fff",
            color: status === "COMPLETED" ? "white" : "#000",
          }}
        />
      </Stack>
      <div className="searchFieldsGrp">
        <TextField
          className="barcodeSearch"
          type="search"
          placeholder="Search by barcode"
          variant="outlined"
          value={searchString ? searchString : ""}
          onChange={(e) => {
            setSearchStaring(e.target.value);
          }}
        />
        <FormControl className="selectCategory">
          <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            size="small"
            value={selectCategory ? selectCategory : "All"}
            onChange={(e) => handleChangeCategory(e.target.value)}
          >
            <MenuItem className="menuItem" value="All">
              All
            </MenuItem>
            <MenuItem className="menuItem" value="PHARMACOGENOMICS">
              PHARMACOGENOMICS
            </MenuItem>
            <MenuItem className="menuItem" value="NUTRIGENOMICS">
              NUTRIGENOMICS
            </MenuItem>
            <MenuItem className="menuItem" value="RISK DISORDERS">
              RISK DISORDERS
            </MenuItem>
            <MenuItem className="menuItem" value="GRAND REPORT">
              GRAND REPORT
            </MenuItem>
          </Select>
        </FormControl>
        <DateRangePicker
          showOneCalendar
          value={
            fromDate && toDate ? [new Date(fromDate), new Date(toDate)] : null
          }
          onChange={handleDateRangeChange}
          placeholder="Select Start Date - End Date"
          style={{ width: 220, fontFamily: "'Poppins', sans-serif" }}
          disabledDate={(date) => {
            return date.getTime() >= new Date().getTime();
          }}
        />
      </div>
    </div>
  );
};

export default FilterOptions;
